export const changePassword = {
  changeCurrentPassword: "Huidige wagwoord",
  changeNewPassword: "Nuwe wagwoord",
  changeConfirmNewPassword: "Bevestig nuwe wagwoord",
  changePasswordMessage: "Voer asseblief jou wagwoord in!",
  changePasswordError: "Die wagwoorde stem nie ooreen nie!",
  changePasswordBtn: "Dien in",
};
